import React from 'react';
import { GiFairyWings } from 'react-icons/gi';
import { FaUser } from 'react-icons/fa'; // Added for missing image placeholder
import { Helmet } from "react-helmet-async";
import './AboutMember.css';



import trustee5 from '../../../assets/about/bishansingh.jpg';
import trustee6 from '../../../assets/about/chailsingh.jpg';
import trustee7 from '../../../assets/about/chakrawartisingh.jpg';
import trustee8 from '../../../assets/about/hanumansingh.jpg';
import trustee9 from '../../../assets/about/ksshekhawat.jpg';
import trustee10 from '../../../assets/about/madhosinghji.jpg';
import trustee11 from '../../../assets/about/manoharsingh.jpg';
import trustee12 from '../../../assets/about/ramsingh.jpg';

// Mapping specific images to specific members
const execData = [
  { name: "Shri Madho Singh Rathore-Chief Eng.(Retd.)", post: "President", image: trustee10 },
  { name: "Prof. Dr. Kalyan Singh Shekhawat", post: "Vice President", image: trustee9 },
  { name: "Col. Manohar Singh Korna (Retd.)", post: "Treasurer", image: trustee11 },
  { name: "Shri Bishan Singh Sodha RPS(Retd.)", post: "Secretary", image: trustee5 },
];

const memberExecData = [
  { name: "Shri Chakrawarti Singh Rakhi Jojawar", post: "Member", image: trustee7 },
  { name: "Shri Hanuman Singh Khangta", post: "Member", image: trustee8 },
  { name: "Shri Ram Singh Jodha Khangar", post: "Member", image: trustee12 },
  { name: "Dr. Bhairoon Singh Bhati Manaklao", post: "Member", image: null }, // No image
  { name: "Shri Chhail Singh Rupawat (Adv.)", post: "Member", image: trustee6 },
];

const trusteeData = [
  { name: "Shri Nahar Singh Ji", post: "Member", image: null },
  { name: "Shri Dr.Laxman Singh Rathod(Retd.)", post: "Member", image: null },
  { name: "Shri Bahadur Singh Rathod(IPS(Retd.))", post: "Member", image: null },
  { name: "Shri Kumbh Singh Ji patawat", post: "Member", image: null },
  { name: "Shri Kesar Singh Rathod", post: "Member", image: null },
  { name: "Shri Jaswant Singh Inda", post: "Member", image: null },
  { name: "Shri Bhawar Singh Khichi", post: "Member", image: null },
  { name: "Shri Prem Singh Rundha", post: "Member", image: null },
  { name: "Shri Arjun Singh Ji", post: "Member", image: null }, // Has image
  { name: "Shri Mahipal Singh Ji", post: "Member", image: null },
  { name: "Shri Shyam Singh Ji Chouhan", post: "Member", image: null },
  { name: "Shri Dr.Mahipal Singh Ji Rathod", post: "Member", image: null },
];

const AboutMember = () => {
  const renderSection = (title, data) => (
    <div className="about-members-section-block">
      <div className="about-members-header">
        <h2 className="about-members-title">{title}</h2>
        <div className="about-members-divider">
          <div className="about-members-line"></div>
          <GiFairyWings className="about-members-icon" />
          <div className="about-members-line"></div>
        </div>
      </div>

      <div className="about-members-grid">
        {data.map((member, index) => (
          <div className="about-members-card" key={index}>
            <div className="about-members-img-wrapper">
              {member.image ? (
                <img
                  src={member.image}
                  alt={member.name}
                  className="about-members-img"
                />
              ) : (
                <div className="about-members-placeholder">
                  <FaUser className="about-members-placeholder-icon" />
                </div>
              )}
            </div>
            <div className="about-members-info">
              <h3 className="about-members-name">{member.name}</h3>
              <p className="about-members-post">{member.post}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>Members | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Learn more about the members of Rajput Shiksha Kosh."
        />
      </Helmet>
      
      <div className="about-members-wrapper">
        <div className="about-members-container">
          {renderSection("RAJPUT SHIKSHA KOSH - EXECUTIVE COMMITTEE", execData)}
          {renderSection("RAJPUT SHIKSHA KOSH - MEMBER EXECUTIVE COMMITTEE", memberExecData)}
          {renderSection("RAJPUT SHIKSHA KOSH - TRUSTEE", trusteeData)}
        </div>
      </div>
    </>
  );
};

export default AboutMember;